import type { CMSType } from "@firecms/core";

export type LocalizedString = Record<string, CMSType>;

export const Locales = {
  ES: "es",
  EN: "en",
  FR: "fr",
  PT: "pt",
} as const;

export type Locale = (typeof Locales)[keyof typeof Locales];

export const LocaleName: Record<Locale, string> = {
  [Locales.ES]: "Español",
  [Locales.EN]: "English",
  [Locales.PT]: "Portuguese",
  [Locales.FR]: "French",
};

/** Default tab order in localized string fields. */
export const LOCALE_ORDER = [
  Locales.ES,
  Locales.PT,
  Locales.EN,
  Locales.FR,
] as const satisfies readonly Locale[];

export const DEFAULT_LOCALE: Locale = LOCALE_ORDER[0];
